export const queuesRoute = '/apartment/queues';
